export enum PaymentType {
  PAID_IN_CASH = 'PAID_IN_CASH',
  PAYMENT_LINK = 'PAYMENT_LINK',
  PREPAID_CODE = 'PREPAID_CODE',
  FREE_ENTRY = 'FREE_ENTRY',
  CUSTOM = 'CUSTOM',
}

export namespace PaymentType {
  export function getAll(): PaymentType[] {
    return [
      PaymentType.PAID_IN_CASH,
      PaymentType.PAYMENT_LINK,
      PaymentType.PREPAID_CODE,
      PaymentType.FREE_ENTRY,
      PaymentType.CUSTOM,
    ];
  }
}
